/**
 * Fix Formie's Stripe dynamic-amount float precision bug.
 *
 * Formie builds the Elements amount as `100 * value` with no rounding redulting and amount like 1826.0000000000002.
 *
 * Note this is only the browser half. Server-side amounts go through
 * DonationPayments::toCents(), which rounds rather than ceils.
 */
;(() => {
    const roundAmount = (target) => {
        const amount = target?.amount

        if (typeof amount === 'number' && Number.isFinite(amount)) {
            target.amount = Math.round(amount)
        }
    }

    document.addEventListener('beforeInit', (event) => {
        const { stripe, elementOptions } = event.detail ?? {}

        // `beforeInit` is a generic name; only act on Formie's Stripe payload.
        if (!elementOptions) {
            return
        }

        roundAmount(elementOptions)

        if (!stripe || stripe.__amountRoundingPatched) {
            return
        }

        // Patched on the instance on `elements.update(this.paymentInformation)`
        // which re-runs `checkDynamicValues()` and recomputes `100 * value`
        if (typeof stripe.checkDynamicValues === 'function') {
            const original = stripe.checkDynamicValues.bind(stripe)

            stripe.checkDynamicValues = (...args) => {
                const result = original(...args)
                roundAmount(stripe.paymentInformation)
                return result
            }

            stripe.__amountRoundingPatched = true
        }
    })
})()
